import { lazy, Suspense } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import SitePage from './SitePage';

// The editor is only downloaded when someone opens /admin, so the public
// site's bundle doesn't grow.
const AdminApp = lazy(() => import('./admin/AdminApp'));

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SitePage />} />
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div className="bg-dark text-light p-5 text-center min-vh-100">Loading editor…</div>}>
              <AdminApp />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
